import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BilanPtaComponent } from './edition/bilan-pta/bilan-pta.component';
import { RapportPerformanceComponent } from './edition/rapport-performance/rapport-performance.component';
import { TableaudBordIndicateurComponent } from './edition/tableaud-bord-indicateur/tableaud-bord-indicateur.component';
import { TableaudBordProjetComponent } from './edition/tableaud-bord-projet/tableaud-bord-projet.component';
import { TepActivitesComponent } from './edition/tep-activites/tep-activites.component';
import { TepGlobalObgrmComponent } from './edition/tep-global-obgrm/tep-global-obgrm.component';
import { TepProjetComponent } from './edition/tep-projet/tep-projet.component';
import { TepSousActivitesComponent } from './edition/tep-sous-activites/tep-sous-activites.component';
import { ActiviteHorsPtaComponent } from './execution/activite-hors-pta/activite-hors-pta.component';
import { EngagementComponent } from './execution/engagements/engagement/engagement.component';
import { OrdonnancementComponent } from './execution/ordonnancements/ordonnancement/ordonnancement.component';
import { RealisationIndicateursComponent } from './execution/realisation-indicateurs/realisation-indicateurs.component';
import { DetailTacheComponent } from './execution/taches/detail-tache/detail-tache.component';
import { EditTacheComponent } from './execution/taches/edit-tache/edit-tache.component';
import { TacheComponent } from './execution/taches/tache/tache.component';
import { ActionComponent } from './plananalytique/actions/action/action.component';
import { AddActionComponent } from './plananalytique/actions/add-action/add-action.component';
import { EditActionComponent } from './plananalytique/actions/edit-action/edit-action.component';
import { AddDirectionComponent } from './plananalytique/directions/add-direction/add-direction.component';
import { DirectionComponent } from './plananalytique/directions/direction/direction.component';
import { EditDirectionComponent } from './plananalytique/directions/edit-direction/edit-direction.component';
import { AddGestionAccesComponent } from './plananalytique/gestion/add-gestion-acces/add-gestion-acces.component';
import { EditGestionAccesComponent } from './plananalytique/gestion/edit-gestion-acces/edit-gestion-acces.component';
import { GestionAccesComponent } from './plananalytique/gestion/gestion-acces/gestion-acces.component';
import { AddIndicateurComponent } from './plananalytique/indicateurs/add-indicateur/add-indicateur.component';
import { EditIndicateurComponent } from './plananalytique/indicateurs/edit-indicateur/edit-indicateur.component';
import { IndicateurComponent, IndicateurServiceService } from './plananalytique/indicateurs/indicateur/indicateur.component';
import { AddServiceComponent } from './plananalytique/services/add-service/add-service.component';
import { EditServiceComponent } from './plananalytique/services/edit-service/edit-service.component';
import { ServiceComponent } from './plananalytique/services/service/service.component';
import { CibleIndicateursComponent } from './planification/cible-indicateurs/cible-indicateurs.component';
import { ImportationPtaComponent } from './planification/importation-pta/importation-pta.component';
import { RevueBudgetaireComponent } from './planification/revue-budgetaire/revue-budgetaire.component';
import { ValidationPtaComponent } from './planification/validation/validation-pta/validation-pta.component';
import { SuiviRoutingModule } from './suivi-routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgbDropdownModule, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DndModule } from 'ngx-drag-drop';
import { NgPipesModule } from 'ngx-pipes';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { SimplebarAngularModule } from 'simplebar-angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { UiModule } from 'src/app/shared/ui/ui.module';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { PagesRoutingModule } from '../../pages-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ExecutionModule } from './execution/execution.module';
import { DetailPtaComponent } from './planification/validation/detail-pta/detail-pta.component';

import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgChartsModule } from 'ng2-charts';
import { BadgeModule } from 'primeng/badge';
import { ChartModule } from 'primeng/chart';
import { FileUploadModule } from 'primeng/fileupload';
import { PaginatorModule } from 'primeng/paginator';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { TabViewModule } from 'primeng/tabview';
import { DateFormatPipe } from 'src/app/shared/pipe/date-format.pipe';
import { ParamGeneralComponent } from '../parametrage/param-general/param-general.component';
import { ConsultaionPdcComponent } from '../pdc/consultaion-pdc/consultaion-pdc.component';
import { DetailPdcProgrammeComponent } from '../pdc/detail-pdc-programme/detail-pdc-programme.component';
import { DetailsPdcActionsComponent } from '../pdc/details-pdc-actions/details-pdc-actions.component';
import { DetailsPdcActivitesComponent } from '../pdc/details-pdc-activites/details-pdc-activites.component';
import { ImportationPdcComponent } from '../pdc/importation-pdc/importation-pdc.component';
import { BudgetByProgrammeComponent } from './edition/budget-by-programme/budget-by-programme.component';
import { DetailTepActiviteOpComponent } from './edition/detail-tep-activite/detail-tep-activite-op.component';
import { DetailTepProjetComponent } from './edition/detail-tep-projet/detail-tep-projet.component';
import { GraphiqueComponent } from './edition/graphique/graphique.component';
import { IndicateurCleComponent } from './edition/indicateur-cle/indicateur-cle.component';
import { TauxExecutionComponent } from './edition/taux-execution/taux-execution.component';
import { DecaissemntComponent } from './execution/decaissemnt/decaissemnt.component';
import { PlanificationComponent } from './plananalytique/indicateurs/planification/planification.component';
import { AddProjetComponent } from './plananalytique/programme/add-projet/add-projet.component';
import { DetailProjetIndicateurComponent } from './plananalytique/programme/detail-projet-indicateur/detail-projet-indicateur.component';
import { EditProjetComponent } from './plananalytique/programme/edit-projet/edit-projet.component';
import { ProjetIndicateurComponent } from './plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { ProjetdirectionComponent } from './plananalytique/projetdirection/projetdirection.component';
import { AddProjetToActiviteComponent } from './planification/add-projet-to-activite/add-projet-to-activite.component';
import { AddSousActivitToActiviteComponent } from './planification/add-sous-activit-to-activite/add-sous-activit-to-activite.component';
import { AddTacheSousActiviteComponent } from './planification/add-tache-sous-activite/add-tache-sous-activite.component';
import { RecommandationComponent } from './planification/recommandation/recommandation.component';
import { RecommandationExecutionComponent } from './execution/recommandation-execution/recommandation-execution.component';
import { PtaGlobalComponent } from './edition/pta-global/pta-global.component';
import { PtaServiceComponent } from './edition/pta-service/pta-service.component';
import { TepPdcComponent } from './edition/tep-pdc/tep-pdc.component';
import { PaiComponent } from './edition/pai/pai.component';
import { EvaluationPtaComponent } from './edition/evaluation-pta/evaluation-pta.component';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card'
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PanelModule } from 'primeng/panel';
import { TraitementRecommendationComponent } from './execution/traitement-recommendation/traitement-recommendation.component';
import { MissionComponent } from './planification/mission/mission.component';
import { TepDirectionComponent } from './edition/tep-direction/tep-direction.component';
import { PtaByPeriodeComponent } from './planification/pta-by-periode/pta-by-periode.component';
import { EditionActivitePrevueComponent } from '../pdc/edition-activite-prevue/edition-activite-prevue.component';
import { IndicateurPerformanceComponent } from './plananalytique/indicateur-performance/indicateur-performance/indicateur-performance.component';
import { AddIndicateurPerformanceComponent } from './plananalytique/indicateur-performance/add-indicateur-performance/add-indicateur-performance.component';
import { EditIndicateurPerformanceComponent } from './plananalytique/indicateur-performance/edit-indicateur-performance/edit-indicateur-performance.component';
import { IndicateurObjectifComponent } from './plananalytique/indicateur-objectif/indicateur-objectif/indicateur-objectif.component';
import { EditIndicateurObjectifComponent } from './plananalytique/indicateur-objectif/edit-indicateur-objectif/edit-indicateur-objectif.component';
import { AddIndicateurObjectifComponent } from './plananalytique/indicateur-objectif/add-indicateur-objectif/add-indicateur-objectif.component';
import { ListingPdcComponent } from '../pdc/listing-pdc/listing-pdc.component';
import { EditionPdcComponent } from '../pdc/edition-pdc/edition-pdc.component';
import { AddPdcComponent } from '../pdc/add-pdc/add-pdc.component';
import { ObjectifSpecifiqueComponent } from './plananalytique/objectif-specifique/objectif-specifique.component';
import { ResultatsComponent } from './plananalytique/resultats/resultats.component';
import { AddObjectifSpecifiqueComponent } from './plananalytique/objectif-specifique/add-objectif-specifique/add-objectif-specifique.component';
import { EditObjectifSpecifiqueComponent } from './plananalytique/objectif-specifique/edit-objectif-specifique/edit-objectif-specifique.component';
import { AddResultatsComponent } from './plananalytique/resultats/add-resultats/add-resultats.component';
import { UpdateResultatsComponent } from './plananalytique/resultats/update-resultats/update-resultats.component';
import { MotDuMaireComponent } from '../parametrage/mot-du-maire/mot-du-maire.component';
import { SlideZoneComponent } from '../parametrage/slide/slide-zone/slide-zone.component';
import { AddSlideComponent } from '../parametrage/slide/add-slide/add-slide.component';
import { UpdateSlideComponent } from '../parametrage/slide/update-slide/update-slide.component';
import { ListingPtaPdcComponent } from '../parametrage/listing-pta-pdc/listing-pta-pdc.component';
import { PoidsPdcComponent } from '../parametrage/poids-pdc/poids-pdc.component';
import { TepPaiComponent } from './edition/pai/tep-pai/tep-pai.component';
import { StatsPaiComponent } from './edition/pai/stats-pai/stats-pai.component';
import { DetailTepRapportComponent } from './edition/rapport-performance/detail-tep-rapport/detail-tep-rapport.component';
import { ChapitreComponent } from './recettes/chapitre/chapitre.component';
import { SousChapitreComponent } from './recettes/sous-chapitre/sous-chapitre.component';
import { CompteBudgetaireComponent } from './recettes/compte-budgetaire/compte-budgetaire.component';
import { PrevisionComponent } from './recettes/prevision/prevision.component';
import { TitresComponent } from './recettes/titres/titres.component';
import { RecouvrementComponent } from './recettes/recouvrement/recouvrement.component';
import { SyntheseRecettesNettesComponent } from './recettes/synthese-recettes-nettes/synthese-recettes-nettes.component';
@NgModule({
  declarations: [

    DashboardComponent,
    // DashboardComponentRecherche,

    ActionComponent,
    AddActionComponent,
    EditActionComponent,
    ProjetIndicateurComponent,
    AddProjetComponent,
    EditProjetComponent,
    AddIndicateurComponent,
    EditIndicateurComponent,
    IndicateurComponent,
    DirectionComponent,
    AddDirectionComponent,
    EditDirectionComponent,
    ServiceComponent,
    AddServiceComponent,
    EditServiceComponent,
    GestionAccesComponent,
    AddGestionAccesComponent,
    EditGestionAccesComponent,
    ImportationPtaComponent,
    ValidationPtaComponent,
    DetailPtaComponent,
    RevueBudgetaireComponent,
    CibleIndicateursComponent,
    ActiviteHorsPtaComponent,
    DetailTacheComponent,
    TacheComponent,
    EditTacheComponent,
    RealisationIndicateursComponent,
    EngagementComponent,
    OrdonnancementComponent,
    BilanPtaComponent,
    RapportPerformanceComponent,
    TableaudBordIndicateurComponent,
    TableaudBordProjetComponent,
    TepActivitesComponent,
    TepSousActivitesComponent,
    TepProjetComponent,
    TepGlobalObgrmComponent,
    DateFormatPipe,
    AddProjetToActiviteComponent,
    AddSousActivitToActiviteComponent,
    AddTacheSousActiviteComponent,
    ProjetdirectionComponent,
    DetailTepActiviteOpComponent,
    DetailTepProjetComponent,
    PlanificationComponent,
    GraphiqueComponent,
    TauxExecutionComponent,
    IndicateurCleComponent,
    DecaissemntComponent,
    // MapsComponent,
    //FormatMoneyPipe,
    // LimitToPipe,
    DetailProjetIndicateurComponent,
    ImportationPdcComponent,
    ParamGeneralComponent,
    DetailsPdcActionsComponent,
    DetailPdcProgrammeComponent,
    DetailsPdcActivitesComponent,
    ConsultaionPdcComponent,
    BudgetByProgrammeComponent,
    RecommandationComponent,
    RecommandationExecutionComponent,
    PtaGlobalComponent,
    PtaServiceComponent,
    TepPdcComponent,
    PaiComponent,
    EvaluationPtaComponent,
    TraitementRecommendationComponent,
    MissionComponent,
    TepDirectionComponent,
    PtaByPeriodeComponent,
    EditionActivitePrevueComponent,
    IndicateurPerformanceComponent,
    AddIndicateurPerformanceComponent,
    EditIndicateurPerformanceComponent,
    TepPaiComponent,
    PoidsPdcComponent,
    StatsPaiComponent,
    //

    IndicateurObjectifComponent,
    EditIndicateurObjectifComponent,
    AddIndicateurObjectifComponent,

    ListingPdcComponent,
    EditionPdcComponent,
    AddPdcComponent,
    ObjectifSpecifiqueComponent,
    ResultatsComponent,
    AddObjectifSpecifiqueComponent,
    EditObjectifSpecifiqueComponent,
    AddResultatsComponent,
    UpdateResultatsComponent,
    MotDuMaireComponent,

    SlideZoneComponent,
    AddSlideComponent,
    UpdateSlideComponent,
    ListingPtaPdcComponent,
    DetailTepRapportComponent,
    ChapitreComponent,
    SousChapitreComponent,
    CompteBudgetaireComponent,
    PrevisionComponent,
    TitresComponent,
    RecouvrementComponent,
    SyntheseRecettesNettesComponent

  ],
  imports: [
    CommonModule,
    SuiviRoutingModule,
    CommonModule,
    UiModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PagesRoutingModule,
    UiModule,
    NgPipesModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgApexchartsModule,
    DndModule,
    FullCalendarModule,
    LeafletModule,
    WidgetModule,
    SimplebarAngularModule,
    TabViewModule,
    ExecutionModule,
    ConfirmDialogModule,
    ToastModule,
    ButtonModule,
    NgxUiLoaderModule,
    MessagesModule,
    FileUploadModule,
    PaginatorModule,
    SharedModule,
    NgChartsModule,
    ChartModule,
    SkeletonModule,
    BadgeModule,
    SliderModule,
    DividerModule,
    TableModule,
    CardModule,
    DialogModule,
    AccordionModule,
    PanelMenuModule,
    PanelModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    })

  ],
  providers: [

    IndicateurServiceService

  ]

})

export class SuiviModule { }
